@if (fallbackUrl && !showParticipant) {
    <img src="{{ fallbackUrl }}" />
}
@if (participantUrl) {
    <img src="{{ participantUrl }}" [hidden]="!showParticipant" (load)="participantImageLoad()" />
}
